var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsersFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7995 32.4128H23.0263C18.2471 32.4183 13.6652 34.3193 10.2859 37.6987C6.90646 41.0781 5.0055 45.6599 5 50.4391C5 50.8069 5.14609 51.1596 5.40614 51.4196C5.66618 51.6797 6.01888 51.8257 6.38664 51.8257H42.4392C42.8069 51.8257 43.1596 51.6797 43.4197 51.4196C43.6797 51.1596 43.8258 50.8069 43.8258 50.4391C43.8203 45.6599 41.9193 41.0781 38.5399 37.6987C35.1606 34.3193 30.5787 32.4183 25.7995 32.4128Z",
    fill: "#D4E1F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4153 35.1862C30.5419 35.1862 35.5084 30.2196 35.5084 24.0931C35.5084 17.9665 30.5419 13 24.4153 13C18.2888 13 13.3223 17.9665 13.3223 24.0931C13.3223 30.2196 18.2888 35.1862 24.4153 35.1862Z",
    fill: "#D4E1F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9734 32.4128H39.2001C34.4209 32.4183 29.8391 34.3193 26.4597 37.6987C23.0803 41.0781 21.1793 45.6599 21.1738 50.4391C21.1738 50.8069 21.3199 51.1596 21.58 51.4196C21.84 51.6797 22.1927 51.8257 22.5605 51.8257H58.613C58.9807 51.8257 59.3334 51.6797 59.5935 51.4196C59.8535 51.1596 59.9996 50.8069 59.9996 50.4391C59.9941 45.6599 58.0932 41.0781 54.7138 37.6987C51.3344 34.3193 46.7525 32.4183 41.9734 32.4128Z",
    fill: "#93B5F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5892 35.1862C46.7157 35.1862 51.6823 30.2196 51.6823 24.0931C51.6823 17.9665 46.7157 13 40.5892 13C34.4626 13 29.4961 17.9665 29.4961 24.0931C29.4961 30.2196 34.4626 35.1862 40.5892 35.1862Z",
    fill: "#93B5F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsersFlat);
export default __webpack_public_path__ + "static/media/IconUsersFlat.c6d9356b2fb47da1fb2ae5a7b1929b77.svg";
export { ForwardRef as ReactComponent };